import React from 'react';

import Router from './services/router';

function App() {
  return <Router />;
}

export default App;
